import { render, staticRenderFns } from "./assistenzaPage.vue?vue&type=template&id=4271bdfc&"
import script from "./assistenzaPage.vue.ts?vue&type=script&lang=ts&"
export * from "./assistenzaPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports